import { Link } from "react-router-dom";
import styles from "./VCAProduct.module.css";

const VCAProduct = ({ data }: any) => {
    const { title, subtitle, features, ctaText, image, link } = data;

    return (
        <Link to={link}>
            <section className={styles.container}>
                <h2 className={styles.title}>{title}</h2>
                <p className={styles.subtitle}>{subtitle}</p>
                <div className={styles.contentWrapper}>
                    <div className={styles.imageSection}>
                        <img src={image} alt=" Phone andTablet with DigiHappy application" className={`${styles.deviceImage} ${styles.tabletImage}`} />
                    </div>
                    <div className={styles.infoSection}>
                        <ul className={styles.featureList}>
                            {features.map((feature: any, index: any) => (
                                <li key={index} className={styles.featureItem}>
                                    <i className={`fas fa-check-circle ${styles.checkIcon}`} />
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={styles.ctaBox}>
                        <p>{ctaText}</p>
                    </div>
                </div>
            </section>
        </Link>
    );
};

export default VCAProduct;
